module.exports = __webpack_public_path__ + "pc/static/img/notice_action.45696492.png";